import { createReducer } from '@reduxjs/toolkit';
import { setSettings } from '@innovyze/stylovyze/lib/actions/app.actions';
import { defaultCompanySettings } from '@innovyze/stylovyze/lib/utils/companySettings';
export const initialState = {
    companySettings: defaultCompanySettings,
};
const reducer = {
    [setSettings.toString()]: (state, action) => ({
        ...state,
        ...action.payload,
        companySettings: {
            ...state.companySettings,
            ...action.payload.companySettings,
        },
    }),
};
export default createReducer(initialState, reducer);
